
























































































































import Vue from 'vue';
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';

import { IQuoteServiceVariable, QuoteServiceVariable } from '@/models';

import { ErrorManager } from '@/models/error';
import QuoteServiceVariableList from '@/components/quoteservicevariable/QuoteServiceVariableList.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import QuoteServiceVariableFormDialog from '@/components/quoteservicevariable/QuoteServiceVariableFormDialog.vue';
import ALPage from '@/components/core/Page/ALPage.vue';

export default Vue.extend({
  components: {
    QuoteServiceVariableList,
    ConfirmationDialog,
    QuoteServiceVariableFormDialog,
    ALPage
  },
  name: 'QuoteServiceVariableListPage',

  data: () => ({
    search: '',

    errorMessage: '',
    detailErrorMessage: '',

    loading: false,

    deleteConfirmDialog: false,
    deleteInProgress: false,

    selectedServiceVariable: null as null | IQuoteServiceVariable
  }),
  computed: {
    quoteServiceVariables: get<IQuoteServiceVariable[]>(
      'quoteServiceVariable/getQuoteServiceVariables'
    )
  },

  methods: {
    openServiceVariableDialog(
      serviceVariable?: IQuoteServiceVariable,
      isEdit = false
    ) {
      const quoteServiceVariableFormDialog = this.$refs
        .quoteServiceVariableFormDialog as InstanceType<
        typeof QuoteServiceVariableFormDialog
      >;

      quoteServiceVariableFormDialog.open(serviceVariable, isEdit);
    },

    removeQuoteServiceVariable(serviceVariable: IQuoteServiceVariable) {
      this.deleteInProgress = true;
      return this.deleteQuoteServiceVariable(serviceVariable.id)
        .then(() => {
          this.deleteConfirmDialog = false;
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.deleteInProgress = false;
        });
    },

    ...mapActions({
      fetchQuoteServiceVariables:
        'quoteServiceVariable/fetchQuoteServiceVariables',
      deleteQuoteServiceVariable:
        'quoteServiceVariable/deleteQuoteServiceVariable'
    }),

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    cancelServiceVariableDeleteDialog() {
      this.clearAllErrors();
      this.selectedServiceVariable = null;
      this.deleteConfirmDialog = false;
    },

    openServiceVariableDeleteDialog(
      selectedServiceVariable: IQuoteServiceVariable
    ) {
      this.selectedServiceVariable = new QuoteServiceVariable(
        selectedServiceVariable
      );
      this.deleteConfirmDialog = true;
    },

    cancelQuoteServiceVariableDeleteDialog() {
      this.deleteConfirmDialog = false;
    }
  }
});
